export const SPOTLIGHT_TITLE = 'Custom Home Spotlight';

export interface SpotlightProject {
  name: string;
  sqft: string;
  beds: string;
  baths: string;
  garage?: string;
  floorPlanSlug?: string;
}

export const SPOTLIGHT_PROJECTS: SpotlightProject[] = [
  {
    name: 'River Ranch',
    sqft: '2,000 Sq. Ft.',
    beds: '3 Beds',
    baths: '2 Baths',
    garage: '2-Car',
    floorPlanSlug: 'river-ranch',
  },
  {
    name: 'Willow',
    sqft: '3,500 Sq. Ft.',
    beds: '3 Beds',
    baths: '3.5 Baths',
    garage: '3-Car',
    floorPlanSlug: 'willow',
  },
  {
    name: 'Hazel',
    sqft: '2,800 Sq. Ft.',
    beds: '3 Beds',
    baths: '2.5 Baths',
    garage: '2-Car',
  },
  {
    name: 'Sparrow',
    sqft: '6,000 Sq. Ft.',
    beds: '6 Beds',
    baths: '4 Baths',
    garage: '3-Car',
  },
  {
    name: 'Sellers',
    sqft: '2,500 Sq. Ft.',
    beds: '3 Beds',
    baths: '3.5 Baths',
    garage: '2-Car',
  },
  {
    name: 'Ling',
    sqft: '1,230 Sq. Ft.',
    beds: '3 Beds',
    baths: '2 Baths',
    garage: '2-Car',
  },
];
